<template>
  <div id="prompt">
    <section role="alertdialog" tabindex="0" aria-labelledby="prompt-title" aria-describedby="prompt-message-wrapper"
             class="slds-modal slds-fade-in-open slds-modal_prompt" aria-modal="true">
      <div class="slds-modal__container">
        <header id="prompt-variant" :class="getVariant + ' slds-modal__header slds-theme_alert-texture'">
          <button class="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse" title="Close">
            <svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
              <use xlink:href="@salesforce-ux/design-system/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
            </svg>
            <span class="slds-assistive-text">Close</span>
          </button>
          <template v-if="title">
            <h2 id="prompt-title" class="slds-text-heading_medium">{{ title }}</h2>
          </template>
          <slot name="header"></slot>
        </header>
        <div class="slds-modal__content slds-p-around_medium slds-text-align--center" id="prompt-message-wrapper">
          <template v-if="message">
            <p id="prompt-message">{{ message }}</p>
          </template>
          <slot name="body"></slot>
        </div>
        <footer class="slds-modal__footer slds-theme_default">
          <slot name="footer"></slot>
        </footer>
      </div>
    </section>
    <div class="slds-backdrop slds-backdrop_open"></div>
  </div>
</template>

<script>
export default {
  name: "Prompt",
  props: {
    variant: String,
    message: String,
    title: String,
  },
  computed: {
    getVariant() {
      let className = '';

      switch (this.variant) {
        case 'success':
          className = 'slds-theme_success';
          break;
        case 'error':
          className = 'slds-theme_error';
          break;
        default:
          className = 'slds-theme_default';
      }

      return className;
    }
  }
}
</script>

<style scoped>

</style>